import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import { SL_GATE } from 'Defaults/modals'
import GetAlertBtn from '../GetAlertBtn'
import { _MinimizedMenu, _MenuItem, _AlertButtonContents, _ToNormalizeSizeButton } from './styles'

const tabNameToIconReverse = {

  listings: 'building',
  buildings: 'search-listings',
}

const MiniSideMenu = (
  {
    showMiniSideBar,
    setMiniSideBarState,
    menuName,
    selectedMiniSideBarMenuState,
    openModal,
    googleAnalyticsEvent,
    userIsAuthentificated,
    drawActive,
    selectedTab,
    onTabChange,
    isArchive,
    schoolDetail,
    schoolEnabled,
  }) => {
  useEffect(() => {
    if(drawActive) selectedMiniSideBarMenuState('')
  }, [drawActive])
  useEffect(() => {
    if(showMiniSideBar) {
      document.querySelector('#closeMiniMenu').focus()
    }
  }, [showMiniSideBar])
  if(!showMiniSideBar) return null
  const nextSelectedTab = selectedTab === 'buildings' ? 'listings' : 'buildings'
  return (
    <_MinimizedMenu
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
        transition: {
          delay: 0.1,
          duration: 0.2,
        },
      }}
      style={{ position: 'absolute', top: '0', zIndex: 1000 }}
    >
      <_ToNormalizeSizeButton
        onClick={() => {
          setMiniSideBarState(false)
          selectedMiniSideBarMenuState('')
        }}
      >
        <button id="closeMiniMenu" aria-label="expend back">
          <SvgIcon name="#icon-arrow-final" width={14} height={14} />
        </button>
      </_ToNormalizeSizeButton>

      <_MenuItem
        tabIndex="0"
        aria-label="open filter"
        selected={menuName === 'filter'}
        direction="col"
        onClick={() => {
          selectedMiniSideBarMenuState(
            menuName === 'filter' ? '' : 'filter',
          )
        }}
      >
        <SvgIcon name="#icon-filter-vertical" width={16} height={16} />
        Filter
      </_MenuItem>
      <GetAlertBtn
        plain
        gate={SL_GATE.AREA_ALERT}
        openModal={openModal}
        googleAnalyticsEvent={googleAnalyticsEvent}
        userIsAuthentificated={userIsAuthentificated}
        schoolDetail={schoolDetail}
        schoolEnabled={schoolEnabled}
      >
        <_AlertButtonContents direction="col" center>
          <SvgIcon name="#icon-alert" width={16} height={16} />
          Alert
        </_AlertButtonContents>
      </GetAlertBtn>
      <_MenuItem
        selected={menuName === 'stats'}
        direction="col"
        center
        onClick={() => {
          selectedMiniSideBarMenuState(
            menuName === 'stats' ? '' : 'stats',
          )
        }}
      >
        <SvgIcon name="#icon-stats" width={16} height={16} />
        Stats
      </_MenuItem>
      {
        !isArchive && (
          <_MenuItem
            aria-label={'switch to ' + nextSelectedTab}
            data-test-id={'listingBuilding'}
            greyBackground
            direction="col"
            center
            selected={menuName === 'listing'}
            onClick={() => {
              onTabChange({
                target: {
                  value: nextSelectedTab,
                },
              })
            }}
          >
            <SvgIcon
              name={`#icon-${tabNameToIconReverse[selectedTab] || 'buildings'}`}
              width={16}
              height={16}
            />
            {nextSelectedTab}
          </_MenuItem>
        )
      }
    </_MinimizedMenu>
  )
}

MiniSideMenu.propTypes = {
  showMiniSideBar: PropTypes.bool,
  setMiniSideBarState: PropTypes.func,
  menuName: PropTypes.string,
  selectedTab: PropTypes.string,
  selectedMiniSideBarMenuState: PropTypes.func,
  openModal: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  onTabChange: PropTypes.func,
  userIsAuthentificated: PropTypes.bool,
  drawActive: PropTypes.bool,
  isArchive: PropTypes.bool,
  schoolEnabled: PropTypes.bool,
  schoolDetail: PropTypes.shape({}),
}
export default MiniSideMenu
